import { staffSession } from '../lib/api';
import { navigate } from '../lib/router';
import { logout, useMe } from '../stores/session';

/** Shown on every page of a session opened from the CRM ("Log in as client"). */
export function StaffSessionBar() {
  const me = useMe();
  if (!me?.signedInBy) return null;
  const name = [me.firstName, me.lastName].filter(Boolean).join(' ') || (me.contactHidden ? 'this client' : me.email);
  const ends = staffSession()?.expiresAt;
  const endsAt = ends ? new Date(ends).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : null;
  if (me.testAccount) {
    // An agent's own practice account: never let a screenshot pass as a real client account.
    return (
      <div role="status" className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-warn px-4 py-1.5 text-center text-[13px] text-black">
        <span>
          <b className="tracking-wider">TEST ACCOUNT</b> · {name} · trading credit only, nothing here is real money{endsAt ? ` · ends at ${endsAt}` : ''}
        </span>
        <button type="button" className="rounded-full border border-black/40 px-3 py-0.5 font-semibold" onClick={() => void logout().then(() => navigate('/login'))}>
          Sign out
        </button>
      </div>
    );
  }
  return (
    <div role="status" className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-warn/30 bg-warn-bg px-4 py-1.5 text-center text-[13px] text-warn">
      <span>
        Viewing as <b>{name}</b>, signed in by {me.signedInBy} from the CRM{endsAt ? ` · ends at ${endsAt}` : ''} · closing this tab signs out.{me.contactHidden ? ' Email and phone are hidden.' : ''} Security
        settings, profile and withdrawals are off.
      </span>
      <button type="button" className="rounded-full border border-warn/40 px-3 py-0.5 font-semibold" onClick={() => void logout().then(() => navigate('/login'))}>
        Sign out
      </button>
    </div>
  );
}
